import React, { Component } from 'react';
import { connect } from 'react-redux';
import PointListWrap from '../../views/point/list/PointListWrap';
import { pointActions } from '../../store/modules/point';
import { _LIST_PAGINATION_MODEL } from '../../store/modules/app/models';
import { POINT_LIST_SEARCH_OPTION_MODEL, POINT_LIST_SORT_OPTION_MODEL } from '../../store/modules/point/models';

class PointListContainer extends Component {
  componentDidMount() {
    this.initiate();
  }

  initiate = () => {
    const { setData } = this.props;

    this.getList({
      searchOption: POINT_LIST_SEARCH_OPTION_MODEL,
      sortOption: POINT_LIST_SORT_OPTION_MODEL,
      pagination: _LIST_PAGINATION_MODEL,
    });

    /**
     *  검색 박스 초기화
     */
    setData({
      path: ['pointList', 'searchData'],
      value: POINT_LIST_SEARCH_OPTION_MODEL,
    });
  };

  getList = (data) => {
    const { getPointList, pointList } = this.props;
    const { searchOption, sortOption, pagination } = pointList;

    getPointList({
      searchOption,
      sortOption,
      pagination,
      ...data,
    });
  };

  render() {
    const { setData, adminSelectList, pointCauseSelectList, pointList } = this.props;

    return (
      <PointListWrap
        setData={setData}
        pointCauseSelectList={pointCauseSelectList}
        pointList={pointList}
        adminSelectList={adminSelectList}
        getList={this.getList}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    pointList: state.point.pointList,
    adminSelectList: state.point.adminSelectList,
    pointCauseSelectList: state.point.pointCauseSelectList,
  };
};

const mapDispatchToProps = {
  setData: pointActions.setData,
  getPointList: pointActions.getPointList,
};

export default connect(mapStateToProps, mapDispatchToProps)(PointListContainer);
